import React from 'react';
import { useSelector } from 'react-redux';
import Button from '@material-ui/core/Button';
import cn from 'classnames';

import styles from '../styles/main/main.module.scss';
import StakeMore from '../../stake-more';
import PropTypes from 'prop-types';
import StakingStub from '../../../staking-stub';

const MainComponent = ({
  stakeType,
  stakeImage,
  stakeClick,
  unstakeClick,
  children,
  closeStakingText,
  isCloseStaking,
}) => {
  const dark = useSelector((state) => state.basic.dark);

  return (
    <div className={cn({ [styles.dark]: dark })}>
      <div className={styles.stakeMoreWrapper}>
        {isCloseStaking ? (
          <StakingStub type={stakeType} icon={stakeImage} text={closeStakingText} />
        ) : (
          <StakeMore type={stakeType} title='Stake More' image={stakeImage} onClick={stakeClick} />
        )}
      </div>
      <div className={cn(styles.unstakeContainer, styles.uni)}>
        <Button className={styles.unstakeButton} onClick={unstakeClick} variant='contained'>
          Unstake
        </Button>
        {children}
      </div>
    </div>
  );
};

MainComponent.propTypes = {
  stakeType: PropTypes.string.isRequired,
  stakeImage: PropTypes.string.isRequired,
  stakeClick: PropTypes.func.isRequired,
  unstakeClick: PropTypes.func.isRequired,
  children: PropTypes.node,
  isCloseStaking: PropTypes.bool,
  closeStakingText: PropTypes.element,
};

MainComponent.defaultProps = {
  disabledUnstakeClaimRewards: false,
  isCloseStaking: false,
};

export default MainComponent;
